import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const links = [
  { href: "#about", label: "About" },
  { href: "#what", label: "Spinal Flow" },
  { href: "#services", label: "Services" },
  { href: "#testimonials", label: "Stories" },
  { href: "#faq", label: "FAQ" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goBook = () => {
    setOpen(false);
    document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-background/75 border-b border-border/40" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 group" data-testid="logo-link">
          <span className="w-9 h-9 rounded-full bg-gradient-to-br from-primary to-secondary inline-flex items-center justify-center text-secondary-foreground font-serif text-lg">
            e
          </span>
          <span className="font-serif text-2xl tracking-tight">Epic Heal</span>
        </a>

        <ul className="hidden lg:flex items-center gap-9 text-sm text-muted-foreground">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="hover:text-foreground transition-colors duration-300 relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-secondary after:transition-all hover:after:w-full"
                data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, '-')}-link`}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden lg:block">
          <Button
            onClick={goBook}
            data-testid="nav-book-btn"
            className="rounded-full px-6 py-5 bg-foreground text-background hover:bg-foreground/85"
          >
            Start Your Healing Journey
          </Button>
        </div>

        <button
          className="lg:hidden p-2 rounded-full hover:bg-card"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-background/95 backdrop-blur-xl border-t border-border/50">
          <ul className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="text-foreground text-lg"
                  data-testid={`mobile-nav-${l.label.toLowerCase()}-link`}
                >
                  {l.label}
                </a>
              </li>
            ))}
            <Button
              onClick={goBook}
              className="rounded-full mt-2 bg-foreground text-background"
              data-testid="mobile-nav-book-btn"
            >
              Start Your Healing Journey
            </Button>
          </ul>
        </div>
      )}
    </header>
  );
}
